import {CalendarEntry} from "../../api/grs";
import moment from "moment";

export function useIsEntryHistoric(entry: CalendarEntry) {
    const now = moment().startOf("day").unix();
    const endOfDay = moment.unix(entry.startDate).endOf("day").unix();
    return endOfDay < now;
}
